export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8264.43552f17.jpg";